const bannerCopy = {
  //! APL is also the Generic choice, aka "None"
  APL: [
    "Want a loan that's fast, simple, and built around you?",
  ],
  AHL: [
    'Need a way to unlock the value of your home?',    
  ],
  AR: ['Struggling with minimum payments?',],
}

// map contentful associatedProduct values to product
const copyMap = {
  'None': 'APL',
  'Personal Loans': 'APL',
  'Debt Resolution': 'AR',
  'Home Equity Loans': 'AHL',
  'Debt Consolidation': 'APL'
}

const getBannerCopy = (associatedProduct = 'None') => {
  const product = copyMap[associatedProduct]
  const copyIndex = Math.floor(Math.random() * bannerCopy[product].length)
  return bannerCopy[product][copyIndex]
}

const quizQuestions = [
  {
    question: 'Do you own a home?',
    nextQuestionOverride: { 0: 1, 1: 2 }, // key==selected option index; val==index of desired next question
    options: ['Yes', 'No'],
  },
  {
    question: 'How much home equity do you think you have?',
    options: ['Less than 20%', 'Over 20%'],
  },
  {
    question: 'How would you rate your credit score?',
    options: ['Good (700+)', 'Fair (620 - 699)', 'Challenged (<620)'],
  },
  {
    question: 'Does your Income cover all your essential bills?',
    options: ['Yes', 'No', 'Barely'],
  },
]

// Regex for google sheet to outcomeMap formatting
// (\w|-)\W(\w|-)\W(\w|-)\W(\w|-)\W(\d{3})
// '$1,$2,$3,$4': $5,

// Create a map where keys are string representations of answer combinations
const outcomeMap = {
  '0,0,0,0': 603,
  '0,0,0,1': 603,
  '0,0,0,2': 603,
  '0,0,1,0': 603,
  '0,0,1,1': 603,
  '0,0,1,2': 603,
  '0,0,2,0': 602,
  '0,0,2,1': 314,
  '0,0,2,2': 314,
  '0,1,0,0': 602,
  '0,1,0,1': 602,
  '0,1,0,2': 314,
  '0,1,1,0': 602,
  '0,1,1,1': 314,
  '0,1,1,2': 314,
  '0,1,2,0': 602,
  '0,1,2,1': 314,
  '0,1,2,2': 314,
  '1,-1,0,0': 602,
  '1,-1,0,1': 602,
  '1,-1,0,2': 602,
  '1,-1,1,0': 602,
  '1,-1,1,1': 314,
  '1,-1,1,2': 314,
  '1,-1,2,0': 314,
  '1,-1,2,1': 314,
  '1,-1,2,2': 314,
}

const resultContentMap = {
  314: {
    spot: '/multi-site-assets/achieve-dr.svg',
    heading: 'Achieve Debt Relief could be a great fit!',
    bullets: [
      'Resolve $7,500-$100,000+ in debt*',
      'Pay down debt in 2-4 years*',
      'Loan alternative to reduce debt*',
    ],
    ctaButton: 'Get my debt plan',
    footer: 'Program guarantee',
    flowRedirectPath: '/get-started?brand=achieve&section=achieve_dr',
  },
  602: {
    spot: '/multi-site-assets/achieve-pl.svg',
    heading: 'Achieve Personal Loans could be a great fit!',
    bullets: [
      '$5,000-$50,000 fixed-rate loans*',
      'Flexible 2, 3, 4, or 5-year terms*',
      'Personalized rate savings*',
    ],
    ctaButton: 'Get my rate',
    footer: "Fast, free, and won't hurt your credit.",
    flowRedirectPath: '/get-started?brand=achieve&section=achieve_pl',
  },
  603: {
    spot: '/multi-site-assets/achieve-hl.svg',
    heading: 'Achieve Home Loans could be a great fit!',
    bullets: [
      '$15,000-$300,000 fixed-rate loans',
      'Flexible 10, 15, 20, and 30-year terms',
      'Save with debt consolidation',
    ],
    ctaButton: 'Find my rate',
    footer: "Fast, free, and won't hurt your credit.",
    footerSpot: '/multi-site-assets/equal-housing.svg',
    flowRedirectPath: '/get-started?brand=achieve&section=achieve_hl',
  },
  0: undefined,
}

const DEFAULT_OUTCOME_ID = 0

const getQuizOutcomeContent = function ({ answers }) {
  // Use the answers array as a key
  const key = answers.join(',')
  const outcome = outcomeMap[key] || DEFAULT_OUTCOME_ID
  return resultContentMap[outcome]
}

export { getQuizOutcomeContent, getBannerCopy, quizQuestions }
